export const environment = {
    heapId: undefined,
    production: true,
    api_url: 'https://api-demo.juyo-intra.com/',
    experimental_features: [],
    externalPlatformUrl: 'https://demo.juyo-intra.com',
    cognito: {
        userPoolId: 'eu-west-1_ZL5XvRoh5',
        userPoolClientId: '4chfbviibfgi7agmu47t2k2nbs',
        domain: 'webjuyo-prod.auth.eu-west-1.amazoncognito.com',
        redirectSignIn: ['https://juyo-ai-demo.juyo-intra.com'],
        redirectSignOut: ['https://juyo-ai-demo.juyo-intra.com'],
    }
};
